export enum BoardCertificationCode {
  BOARD_CERTIFIED = 'BOARD CERTIFIED',
  NOT_BOARD_CERTIFIED = 'NOT BOARD CERTIFIED',
  BOARD_CERTIFICATION_NOT_APPLICABLE = 'BOARD CERTIFICATION NOT APPLICABLE'
}
